<template>
  <SearchResultView :seo-type="_usageCategoryId"></SearchResultView>
</template>
<script setup>

import SearchResultView from "@/components/SearchResult/SearchResultView.vue";

definePageMeta({
  title: '搜尋結果'
})
import {onMounted, provide} from "vue";
import {useRouteQuery} from "@vueuse/router";

import {useQueryFormatter} from "@/composables/useQueryFormatter";
import {useSearchWithStore} from "@/composables/useSearchWithStore";

const route = useRoute();
const router = useRouter()

const {handleSearchWithStore} = useSearchWithStore()
const {setSearchQueryRouteToStore} = useQueryFormatter()
const _usageCategoryId = useRouteQuery('_usageCategoryId', []);


const layoutProps = {
  footer: false
};
provide('searchBasicLayoutProps', layoutProps);

const seoMeta = {
  title: '場地租借到空間便利店，快速找到理想空間！',
  description: '場地租借平台推薦選空間便利店！我們提供多樣化的場地租借空間、多種時段方案，加上預約流程簡單快速，可讓您輕鬆找到理想場地！想了解更多推薦場地和租借秘訣？快往下閱讀我們的場地租借筆記吧！',
  keywords: '場地租借、會議室、攝影棚、廚房租借、活動空間、餐廳包廂、聚會場地，都可線上預約',
  ogTitle: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  ogSiteName: '空間便利店',
  ogDescription: '空間便利店是一個線上的場地租借平台。我們提供線上預約，省去聯絡，方便又順利。活動空間、會議室，攝影棚、餐廳包廂、聚會場地都可預約。',
  ogImage: 'https://pic.onestep.place/images/onestep-og.png',
  ogImageAlt: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  ogUrl: 'https://www.onestep.place',
  ogType: 'website',
};

useSeoMeta(seoMeta);


onMounted(() => {

  if (route.query.sid) {
    router.push({path: `/space/${route.query.sid}`})
  }

  // 檢查是否有有效的查詢參數
  const hasValidQuery = (query) => query && Object.keys(query).length > 0;

  // 處理路由查詢參數的主邏輯
  const processRouteQuery = (query) => {
    setSearchQueryRouteToStore(query);
    handleSearchWithStore();
  };

  // 主執行流程
  if (hasValidQuery(route.query)) {
    processRouteQuery(route.query);
  }

})
</script>

<style scoped
       lang="scss">

</style>
